import React, { useEffect, useState } from 'react';
import { loadReleases } from '../controllers/releaseController';
import Loader from '../components/Loader';
import { loadStatistics, loadMagazineStats, loadSubscriberStats, loadStats } from '../controllers/statisticsController';
import SubscriberChart from './SubscriberChart';
import StatisticChart from './StatisticChart';
import { useNavigate } from 'react-router-dom';
import SubscriberStatisticsView from './SubscriberStatisticsView';


import {
    BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer,
    LineChart, Line, CartesianGrid, Label
} from 'recharts';

const StatisticsView = () => {
    const [releases, setReleases] = useState([]);
    const [selectedReleaseId, setSelectedReleaseId] = useState('');
    const [statistics, setStatistics] = useState([]);
    const [loading, setLoading] = useState(true);
    const [subscriberData, setSubscriberData] = useState([]);
    const [statisticData, setStatisticsData] = useState([]);
    const [viewSubscriberStats, setViewSubscriberStats] = useState(null);
    const navigate = useNavigate();

    var MAGAZINE_ID = null;
    var magazineL = localStorage.getItem('magazine');


    useEffect(() => {
        if (magazineL) {
            MAGAZINE_ID = JSON.parse(magazineL).magazine_id;
        }

        loadMagazineStats(MAGAZINE_ID, (data) => {
            setStatistics(data);
            loadReleases(setReleases);
            setLoading(false);
        });
        loadSubscriberStats(MAGAZINE_ID, (data) => {
            setSubscriberData(data);
            // setLoading(false);
        });
        loadStats(MAGAZINE_ID, (data) => {
            setStatisticsData(data);
            // setLoading(false);
        });

    }, []);

    useEffect(() => {
        if (magazineL) {
            MAGAZINE_ID = JSON.parse(magazineL).magazine_id;
        }
        if (!viewSubscriberStats) {
            setLoading(true);
            if (selectedReleaseId) {
                loadStatistics(selectedReleaseId, (data) => {
                    setStatistics(data);
                    setLoading(false);
                });
            } else {
                loadMagazineStats(MAGAZINE_ID, (data) => {
                    setStatistics(data);
                    setLoading(false);
                });
            }
        }
    }, [selectedReleaseId, viewSubscriberStats]);

    if (viewSubscriberStats) {
        return (
            <div className="p-4">
                <button
                    className="btn btn-outline-primary mb-3"
                    onClick={() => setViewSubscriberStats(null)}
                >
                    ← Back to Statistics
                </button>
                <SubscriberStatisticsView
                    releaseId={viewSubscriberStats.release_id}
                    action={viewSubscriberStats.action}
                />
            </div>
        );
    }

    return (
        <div className="p-4">
            <div className='row'>
                <div className='col-lg-6 d-flex align-items-stretch'>
                    <div className='card w-100'>
                        <div className='card-body'>
                            <h4 className="text-sm mb-4 font-bold">Release Wise Statistics</h4>
                            <select
                                className="border p-2 mb-4 form-select"
                                onChange={(e) => setSelectedReleaseId(e.target.value)}
                                value={selectedReleaseId}
                            >
                                <option value="">Select Release</option>
                                {releases.map((release) => (
                                    <option key={release.id} value={release.id}>
                                        {release.display_name}
                                    </option>
                                ))}
                            </select>
                            {(loading) ? <Loader /> :
                                statistics.length === 0 ? (
                                    <div className="text-center text-muted pb-4">No Data Available</div>
                                ) : (
                                    <ResponsiveContainer width="100%" height={300}>
                                        <BarChart data={statistics} >
                                            <XAxis dataKey="action" />
                                            <YAxis />
                                            <Tooltip />
                                            <Legend />
                                            <Bar dataKey="count" fill="#8884d8" name="Total"
                                                onClick={(data) => {
                                                    if (data && data.release_id && data.action) {
                                                        setViewSubscriberStats({
                                                            release_id: data.release_id,
                                                            action: data.action
                                                        });
                                                    }
                                                }}
                                            />
                                            {/* <Bar dataKey="percentage" fill="#82ca9d" name="Percentage" /> */}
                                        </BarChart>
                                    </ResponsiveContainer>
                                )}
                        </div>
                    </div>
                </div>
                <div className='col-lg-6 d-flex align-items-stretch'>
                    <div className='card w-100'>
                        <div className='card-body'>
                            {(subscriberData && subscriberData.length) === 0 ? (
                                <div className="container my-4 mb-5">
                                    <p className="text-center text-muted">No subscriber data available.</p></div>
                            ) : <div className="container mb-5"><SubscriberChart data={subscriberData} /> </div>}
                        </div>
                    </div>
                </div>
                <div className='col-lg-6 d-flex align-items-stretch'>
                    <div className='card w-100'>
                        <div className='card-body'>
                            {(statisticData && statisticData.length) === 0 ? (
                                <div className="container my-4 mb-5">
                                    <p className="text-center text-muted">No subscriber data available.</p></div>
                            ) : <div className="container mb-5"><StatisticChart data={statisticData} /> </div>}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default StatisticsView;
